import axios from '../../../axios'

export const getWoDefectStat = (data) => {
  return axios({
    url: '/stat/woDefect/getWoDefectStat',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/stat/statWoDefect.js